import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useCategories } from '@/hooks/useCategoryQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { CreateCategoryForm } from './CreateCategoryForm';

export const CreateCategoryPage: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.CATEGORIES);
  const [searchParams] = useSearchParams();
  const defaultParentId = searchParams.get('parentId')
    ? Number(searchParams.get('parentId'))
    : undefined;
  const { data: categories = [] } = useCategories();
  const rootCategories = categories.filter((c) => c.parentId === null);
  const title = defaultParentId ? 'Нова підкатегорія' : 'Нова категорія';

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>{title}</h2>
      </FormPageHeader>
      <FormCard>
        <CreateCategoryForm defaultParentId={defaultParentId} parentCategories={rootCategories} />
      </FormCard>
    </FormPageContainer>
  );
};
